import { ApiLottoRicercaGetRequest, Configuration, DettaglioListLottoDtoPagedListDto, LottoApi } from '@desio/api';
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { dateWithTime } from 'helpers/utils';
import { ThunkApiConfig } from 'store';
import getConfiguration, { errorHandler } from 'store/config';
import { pageSize } from 'store/utils';


export const setRicercaNome = createAction<string, 'campagne/setRicercaNome'>('campagne/setRicercaNome');
export const setRicercaDataInizio = createAction<Date, 'campagne/setRicercaDataInizio'>('campagne/setRicercaDataInizio');
export const setRicercaDataFine = createAction<Date, 'campagne/setRicercaDataFine'>('campagne/setRicercaDataFine');
export const setRicercaStatoCampagna = createAction<number, 'campagne/setRicercaStatoCampagna'>('campagne/setRicercaStatoCampagna');


export const postRicercaLotti = createAsyncThunk<DettaglioListLottoDtoPagedListDto | undefined, void, ThunkApiConfig>(
  'campagne/postRicercaLotti', async (_, { dispatch, extra, getState }) => {
    try {
      if (extra.mock) {
        // return (await import('../mock/get-ricerca-lotto.json')).default;
      } else {
        const obj: ApiLottoRicercaGetRequest = {
          dataInizio: dateWithTime(getState().homeCampagna.formRicerca.dataInserimentoInizio, "start"),
          dataFine: dateWithTime(getState().homeCampagna.formRicerca.dataInserimentoFine, "end"),
          pageSize,
          pageNumber: !!getState().homeCampagna.paginaSelezionata ? getState().homeCampagna.paginaSelezionata : undefined,
          nome: getState().homeCampagna.formRicerca.nome,
          stato: getState().homeCampagna.formRicerca.statoCampagna || undefined,
        }
        return await new LottoApi(getConfiguration(Configuration, extra, getState)).apiLottoRicercaGet(obj);
      }
    } catch (error) {
      errorHandler(error, dispatch);
    }
  }
);

export const setPaginaSelezionataAction = createAction<number, 'campagne/setPaginaSelezionataAction'>('campagne/setPaginaSelezionataAction');
